export default "__VITE_ASSET__8eg_4geV__"